import React from "react";
import Gimage from "./Gimage";

const BoothLogo:React.FC = () => {
    return(
        <Gimage src={"Hanka_Bumon_Logo.png"} style={{position:"absolute",right:"2vw",bottom:"2vw",width:"200px"}}/>
    );
};

export default BoothLogo;